import { formatCurrency } from './helpers';

export const formatCurrencyIDR = (
  value: string | number,
  useCents: boolean = false,
  isLangId: boolean = false,
) => {
  return (
    String(value).replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${isLangId ? '.' : ','}`,
    ) + (useCents ? (isLangId ? ',00' : '.00') : '')
  );
};

/**
 * @deprecated use numeral locale
 */
export const formatCurrencyForeign = (value: string) => {
  let tempValue = value.replace('.', '').replace(',', '').replace(/\D/g, '');

  if (tempValue !== '0') {
    if (!tempValue) {
      tempValue = '000';
    }

    if (tempValue.charAt(0) === '0' && tempValue !== '000') {
      tempValue = tempValue.slice(1);
    }

    while (tempValue.length < 3) {
      tempValue = '0' + tempValue;
    }

    let result =
      tempValue.slice(0, tempValue.length - 2) + '.' + tempValue.slice(-2);

    return result;
  }

  return '';
};

export const formatCurrencyForeignNumeral = (
  value: string,
  isLangId: boolean,
) => {
  if (!value) {
    value = '0';
  }

  value = Number(value).toFixed(2);
  const tempListString = value.split('.');

  const thousandSeperator = isLangId ? '.' : ',';
  const decimalSeperator = isLangId ? ',' : '.';

  value =
    tempListString[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousandSeperator}`,
    ) +
    decimalSeperator +
    tempListString[1];

  return value;
};

export const currencyInputFormat = (numStr: string) => {
  if (numStr === '') return '';
  return formatCurrency(numStr);
};
